import React, { useContext } from 'react'
import { ListGroup } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

import { useTranslation } from 'react-i18next'
import NavIcon from '../NavIcon'
import NavBadge from '../NavBadge'

import { ConfigContext } from '../../../../../contexts/ConfigContext'
import * as actionType from '../../../../../store/actions'
import useWindowSize from '../../../../../hooks/useWindowSize'
import { NewItemCounterContext } from '../../../../../contexts/WebSocketContext'

function NavItem({ layout, item }) {
  const windowSize = useWindowSize()
  const configContext = useContext(ConfigContext)
  const newItemCounter = useContext(NewItemCounterContext)
  const { dispatch } = configContext
  const { t } = useTranslation()

  let itemTitle = t(item.title)
  if (item.icon) {
    itemTitle = <span className="pcoded-mtext">{t(item.title)}</span>
  }

  let itemTarget = ''
  if (item.target) {
    itemTarget = '_blank'
  }

  let subContent
  if (item.external) {
    subContent = (
      <a href={item.url} target="_blank" rel="noopener noreferrer">
        <NavIcon items={item} />
        {itemTitle}
        <NavBadge items={item} />
      </a>
    )
  } else {
    subContent = (
      <NavLink to={item.url} className="nav-link" exact target={itemTarget}>
        <NavIcon items={item} />
        {itemTitle}
        {newItemCounter[item.id] && newItemCounter[item.id].number > 0 && (
          <>
            <NavBadge items={item} />
            <span
              className="pcoded-badge label"
              style={{ backgroundColor: newItemCounter[item.id].color }}
            >
              {newItemCounter[item.id].number}
            </span>
          </>
        )}
      </NavLink>
    )
  }
  let mainContent = ''
  if (layout === 'horizontal') {
    mainContent = (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        onClick={() => dispatch({ type: actionType.NAV_CONTENT_LEAVE })}
      >
        {subContent}
      </ListGroup.Item>
    )
  } else if (windowSize.width < 992) {
    mainContent = (
      <ListGroup.Item
        as="li"
        bsPrefix=" "
        className={item.classes}
        onClick={() => dispatch({ type: actionType.COLLAPSE_MENU })}
      >
        {subContent}
      </ListGroup.Item>
    )
  } else {
    mainContent = (
      <ListGroup.Item as="li" bsPrefix=" " className={item.classes}>
        {subContent}
      </ListGroup.Item>
    )
  }

  return mainContent
}

export default NavItem

